import React from "react";
import "./EmailSignup.css";

class EmailSignup extends React.Component {
  state = {
    input: '',
    sent: false,
  };
  handleChange = (e) => {
    const { value } = e.target;
    this.setState({ input: value });
  };
  handleSubmit = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const { input } = this.state;
    const formData = new FormData();

    formData.append("u", "0b12f54dc53b6eed7c520e681");
    formData.append("id", "f350f71e2c");
    formData.append("MERGE0", input);

    var request = new XMLHttpRequest();
    request.open("POST", "https://evolutionofcannabis.us19.list-manage.com/subscribe/post");
    request.send(formData);
    this.setState({ input: '', sent: true });
    return false;
  };
  render() {
    const { urls } = this.props;
    const { input, sent } = this.state;
    if (urls && urls.length > 0) {
      return (
        <div className="signup-container">
          <form className={sent ? 'completed' : null} onSubmit={this.handleSubmit} action="https://evolutionofcannabis.us19.list-manage.com/subscribe/post" method="POST">
            <input type="hidden" name="u" value="0b12f54dc53b6eed7c520e681" />
            <input type="hidden" name="id" value="f350f71e2c" />
            {
              sent ? (
                <div className="signup-complete">Thank you! You'll hear some more news soon.</div>
              ) : [
                <label key="label">
                  <span>Sign up for news and updates</span>
                  <input
                    autoCapitalize="off"
                    autoCorrect="off"
                    name="MERGE0"
                    id="MERGE0"
                    type="text"
                    placeholder="Email"
                    value={input}
                    onChange={this.handleChange}
                  />
                </label>,
                <button key="button">Sign Up</button>,
              ]
            }
          </form>
        </div>
      );
    }
    return null;
  }
}

export default EmailSignup;



// WEBPACK FOOTER //
// ./src/components/EmailSignup/EmailSignup.jsx